import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Images from "../constants/Images";
import "./NavBar.css";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Modal, Spinner } from "react-bootstrap";
import { apiRequest } from "../services";
import "@fortawesome/fontawesome-free/css/all.css";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 60 minutes
const NavBar = () => {
  const { t } = useTranslation();
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const handleClick = () => setClick(!click);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const closeMobileMenu = () => setClick(false);
  const [formError, setFormError] = useState({
    userNameOrEmail: null,
    password: null,
  });
  const [navigateTo, setNavigateTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    password: "",
    userNameOrEmail: "",
  });

  const [viewpassword, setViewPassword] = useState(false);
  const navigate = useNavigate();

  const TogglePassword = (event) => {
    event.preventDefault();
    setViewPassword(!viewpassword);
  };

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.users);
  console.log("NAVBAR userdata",userData)

  const handleLogout = () => {
    dispatch({
      type: "LOGOUT",
      value: {},
    });
    console.log("Logout");
    navigate("/");
  };

  const showButton = () => {
    if (window.innerWidth <= 615) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const validateForm = (fieldName, currentFormData) => {
    const errors = { ...formError };

    switch (fieldName) {
      case "userNameOrEmail":
        if (!currentFormData.userNameOrEmail) {
          errors.userNameOrEmail = t("requiredField");
        } else {
          delete errors.userNameOrEmail;
        }
        break;
      case "password":
        if (!currentFormData.password) {
          errors.password = t("requiredField");
        } else if (currentFormData.password.length !== 5) {
          errors.password = t("votre mot de passe doit avoir 5 chiffres");
        } else {
          delete errors.password;
        }
        break;

      default:
        break;
    }
    setFormError(errors);
  };

  useEffect(() => {
    showButton();
    window.addEventListener("resize", showButton);
    return () => window.removeEventListener("resize", showButton);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    validateForm(name, { ...formData, [name]: value });
  };

  const hideAddLoginModal = (e) => {
    setShowModal(!showModal);
  };

  const handleToggleLoginModalSubscription = (route) => {
    setNavigateTo(route);
    navigate(route);
    hideAddLoginModal();
  };

  const handleToggleLoginModal = (route) => {
    if (userData?.users?.userName) {
      setNavigateTo(route);
      navigate(route);
    } else {
      setShowModal(!showModal);
      setNavigateTo(route);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div
          className="d-flex align-items-center "
          style={{ marginLeft: "40px" }}
        >
          <Link to="/" className="navbar-logo ">
            <img
              className="mb-1"
              src={Images.digital}
              height={120}
              width={120}
            />
          </Link>
          <div className="">
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <Link to="/" className="nav-links" onClick={closeMobileMenu}>
                  {t("home")}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/about"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  {t("about")}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/faq" className="nav-links" onClick={closeMobileMenu}>
                  {t("faq")}
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link
                  to="/contact"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  {t("contact")}
                </Link>
              </li> */}
              <li className="nav-item">
                <Link to="/tec" className="nav-links" onClick={closeMobileMenu}>
                  {t("termeEtConditions")}
                </Link>
              </li>
              {/* {userData?.users?.userName
                ? ""
                : button && (
                    <li className="nav-item ml-4 mt-1">
                      <Button
                        className="btns mt-3 mr-3 "
                        onClick={handleToggleLoginModal}
                      >
                        {t("signIn")}
                      </Button>
                    </li>
                  )} */}
            </ul>
          </div>
        </div>
        <div className="">
          {userData?.users?.clientDetails?.fullName ? (
            <div className="dropdown me-2">
              <a
                className="dropdown-toggle d-flex align-items-center"
                style={{
                  color: "rgba(0,0,0,.25)",
                  textDecoration: "none",
                  minWidth: "40px", // Garantit un espace minimal sur mobile
                }}
                id="dropdownMenu2"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {userData?.users?.clientDetails?.profilePhoto ? (
                  <img
                    alt="avatar"
                    src={userData.users.clientDetails.profilePhoto}
                    className="rounded-circle-nav border-2 border-white shadow-sm"
                    style={{
                      objectFit: "cover",
                      width: "clamp(30px, 4vw, 40px)", // Adaptatif entre 30px et 40px
                      height: "clamp(30px, 4vw, 40px)",
                    }}
                  />
                ) : (
                  <img
                    alt="default avatar"
                    src={Images.avatarwhite}
                    className="rounded-circle-nav border-2 border-white shadow-sm"
                    style={{
                      objectFit: "cover",
                      width: "clamp(30px, 4vw, 40px)",
                      height: "clamp(30px, 4vw, 40px)",
                    }}
                  />
                )}
              </a>

              <ul
                className="dropdown-menu dropdown-menu-end shadow-lg border-0"
                aria-labelledby="dropdownMenu2"
                style={{
                  minWidth: "min(280px, 90vw)", // Ne dépasse pas 280px ou 90% de l'écran
                  borderRadius: "12px",
                  overflow: "hidden",
                  marginTop: "10px",
                  border: "none",
                }}
              >
                {/* Header */}
                <div
                  className="d-flex align-items-center p-2 p-md-3 bg-gradient-primary"
                  style={{
                    background:
                      "linear-gradient(135deg, hsl(182, 80%, 43%) 0%, rgb(26, 23, 23) 100%)",
                    color: "white",
                  }}
                >
                  <div className="me-2 me-md-3">
                    {userData?.users?.clientDetails?.profilePhoto ? (
                      <img
                        alt="avatar"
                        src={userData.users.clientDetails?.profilePhoto}
                        className="rounded-circle shadow"
                        style={{
                          width: "clamp(40px, 8vw, 50px)",
                          height: "clamp(40px, 8vw, 50px)",
                          objectFit: "cover",
                          border: "2px solid white",
                        }}
                      />
                    ) : (
                      <img
                        alt="default avatar"
                        src={Images.avatar}
                        className="rounded-circle shadow"
                        style={{
                          width: "clamp(40px, 8vw, 50px)",
                          height: "clamp(40px, 8vw, 50px)",
                          objectFit: "cover",
                          border: "2px solid white",
                        }}
                      />
                    )}
                  </div>
                  <div style={{ fontSize: "clamp(0.8rem, 2vw, 1rem)" }}>
                    {userData?.users?.clientDetails?.fullName ? (
                      <div>
                        <strong
                          className="d-block text-truncate"
                          style={{ maxWidth: "150px" }}
                        >
                          {userData.users?.clientDetails?.fullName}
                        </strong>
                        <small className="text-white-50">Mon compte</small>
                      </div>
                    ) : (
                      <h6 className="mb-0 text-white">{t("nouser")}</h6>
                    )}
                  </div>
                </div>

                {/* Menu Items */}
                {userData?.users?.clientDetails?.fullName && (
                  <>
                    <li>
                      <button
                        className="dropdown-item d-flex align-items-center py-2 px-2 px-md-3"
                        type="button"
                        onClick={() => navigate("/viewuserinfo")}
                      >
                        <i className="fa-solid fa-address-card me-2 me-md-3 text-primary"></i>
                        <span className="text-truncate">
                          {t("viewuserDetails")}
                        </span>
                        <i
                          className="fas fa-chevron-right ms-auto text-muted"
                          style={{ fontSize: "0.7rem" }}
                        ></i>
                      </button>
                    </li>
                    <li>
                      <hr className="dropdown-divider my-1 mx-2" />
                    </li>
                  </>
                )}

                <li>
                  <button
                    className="dropdown-item d-flex align-items-center py-2 px-2 px-md-3"
                    onClick={() => handleLogout()}
                    type="button"
                  >
                    <i className="fa-solid fa-arrow-right-from-bracket me-2 me-md-3 text-danger"></i>
                    <span className="text-truncate">{t("signOut")}</span>
                  </button>
                </li>

                {/* Footer */}
                <div
                  className="px-2 px-md-3 py-1 py-md-2 bg-light"
                  style={{ fontSize: "clamp(0.65rem, 2vw, 0.8rem)" }}
                >
                  <small className="text-muted d-block text-truncate">
                    Version {process.env.REACT_APP_VERSION}
                  </small>
                </div>
              </ul>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="menu-icon" onClick={handleClick}>
          <FontAwesomeIcon
            icon={click ? faTimes : faBars}
            className={click ? "icon-white" : ""}
          />
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={handleToggleLoginModal}
        centered
        size="lg"
        className="modal-responsive"
      >
        <Modal.Header className="modal-header-spaced">
          <img
            src={Images.digital}
            style={{ height: "100px", width: "100px" }}
            alt="logo-image"
          />
          <Modal.Title>{t("CONNECTEZ-VOUS")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4">
          <Form className="row g-3">
            <Col xs="12" sm="12" md="12" lg="6" xl="12">
              <div className="mb-3">
                <label htmlFor="userName" className="form-label fw-semibold">
                  <i className="bi bi-person-circle me-2"></i>{" "}
                  {t("insuranceID")}
                </label>
                <input
                  type="text"
                  className={`form-control rounded-3 p-2 shadow-sm  ${
                    formError.userNameOrEmail ? "is-invalid" : ""
                  }`}
                  id="userNameOrEmail"
                  placeholder={t("enterInsuranceID")}
                  name="userNameOrEmail"
                  value={formData.userNameOrEmail}
                  onChange={handleChange}
                  required
                />
                {formError.userNameOrEmail && (
                  <div className="invalid-feedback">
                    {formError.userNameOrEmail}
                  </div>
                )}
              </div>
            </Col>
            <Col xs="12" sm="12" md="12" lg="6" xl="12">
              <div className="mb-3">
                <label htmlFor="password" className="form-label fw-semibold">
                  <i className="bi bi-lock me-2"></i> {t("techCarePIN")}
                </label>
                <div className="password-input-wrapper">
                  <input
                    type={viewpassword ? "text" : "password"}
                    className={`form-control rounded-3 p-2 pe-5 ${
                      formError.password ? "is-invalid" : ""
                    }`}
                    id="password"
                    name="password"
                    placeholder={t("enterPIN")}
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      TogglePassword(e);
                    }}
                    className="password-toggle-btn"
                    aria-label={
                      viewpassword ? "Hide password" : "Show password"
                    }
                  >
                    <FontAwesomeIcon
                      icon={viewpassword ? faEye : faEyeSlash}
                      className="icon-size"
                    />
                  </button>
                  {formError.password && (
                    <div className="invalid-feedback">{formError.password}</div>
                  )}
                </div>
              </div>
            </Col>
          </Form>

          {/* Messages d'erreur et de succès */}
          {errorMessage && (
            <div className="alert alert-danger rounded-3">{errorMessage}</div>
          )}
          {successMessage && (
            <div className="alert alert-success rounded-3">
              {successMessage}
            </div>
          )}

          {/* Section des boutons */}
          <div className="text-center mt-4">
            {/* <Button
              className="btn w-100 mb-2 btn-primary rounded-3 p-2 shadow-sm"
              onClick={handleLoginNavBar}
            >
              {loading ? <Spinner size="md" variant="light" /> : t("signIn")}
            </Button> */}

            <small className="d-block mb-2 text-muted">
              Vous n'avez pas de compte ? Inscrivez-vous
            </small>

            <Button
              className="btn w-100 btn-success rounded-3 p-2 shadow-sm"
              onClick={() =>
                handleToggleLoginModalSubscription("/subscription")
              }
            >
              S'INSCRIRE
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </nav>
  );
};

export default NavBar;
